var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "goods-category"
  }, [_c('div', {
    staticClass: "text-2xl font-bold mb-6"
  }, [_vm._v("Master Data Goods Category")]), _c('div', {
    staticClass: "border shadow-lg rounded-md bg-white"
  }, [_c('div', {
    staticClass: "p-6 flex justify-between"
  }, [_c('div', {
    staticClass: "flex items-center gap-4"
  }, [_c('div', {
    staticClass: "w-60"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "action": _vm.doSearch,
      "placeholder": "Masukan kata kunci"
    },
    model: {
      value: _vm.keyword,
      callback: function ($$v) {
        _vm.keyword = $$v;
      },
      expression: "keyword"
    }
  })], 1), _c('div', {}, [_c('Button', {
    attrs: {
      "buttonText": "Cari"
    },
    on: {
      "action": function ($event) {
        return _vm.doSearch();
      }
    }
  })], 1)]), _c('div', {}, [_c('LinkButton', {
    attrs: {
      "buttonText": "Tambah Kategori Barang",
      "url": {
        name: 'Create Order'
      },
      "linkType": "internal"
    }
  })], 1)]), _c('TableComponent', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function () {
        return [_c('td', {
          staticClass: "w-16 text-center"
        }, [_vm._v("No.")]), _c('td', {
          staticClass: "w-96"
        }, [_vm._v("Nama")]), _c('td', [_vm._v("Kode")]), _c('td', {
          staticClass: "text-right"
        }, [_vm._v("Opsi")])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function () {
        return [_vm.filteredData && _vm.filteredData.length > 0 ? _vm._l(_vm.filteredData, function (item, index) {
          return _c('tr', {
            key: item.code + index
          }, [_c('td', {
            staticClass: "w-16 text-center"
          }, [_vm._v(_vm._s(index + 1))]), _c('td', {
            staticClass: "w-96"
          }, [_vm._v(_vm._s(item.name))]), _c('td', [_vm._v(_vm._s(item.code))]), _c('td', {
            staticClass: "text-right leading-0"
          }, [_c('span', {
            staticClass: "inline-block py-1 px-2 border cursor-pointer border-system-error rounded-md hover:bg-neutral-300"
          }, [_c('Trash', {
            attrs: {
              "color": "system-error"
            }
          })], 1)])]);
        }) : [_c('tr', [_c('td', {
          staticClass: "text-center",
          attrs: {
            "colspan": "5"
          }
        }, [_c('div', {
          staticClass: "py-6"
        }, [_vm._v("Tidak ada data yang tersedia untuk kata kunci yang Anda masukan.")])])])]];
      },
      proxy: true
    }])
  })], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }